import { Container } from "@mui/material";
import SectionTitle from "../../components/SectionTitle";
import { GENERALS } from "../../constants";

const { text, listTitle, list } = GENERALS;
const GeneralsSection = () => {
  return (
    <section id="about">
      <Container
        sx={{
          whiteSpace: "pre-wrap",
        }}
      >
        <SectionTitle title={"REBEL"}></SectionTitle>
        <SectionTitle title={"GENERALS"}></SectionTitle>
        <p>{text}</p>
        <div style={{ textAlign: "left" }}>
          <strong>{listTitle}</strong>
          <ul>
            {list.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      </Container>
    </section>
  );
};

export default GeneralsSection;
